import { getAddonRestrictionDetails } from '../constants/AddonsRestrictionMap';
import { ALL_AVAILABLE_ADD_ONS } from '../constants/AllAvailableAddOns';
import { getCurrentProductVersion, getCurrentSkuIdForProduct, getProduct } from './productsUtils';
export const getEligibleAddOnSkuIds = (state, {
  productConfigurations
}) => {
  return ALL_AVAILABLE_ADD_ONS.filter(apiName => {
    const product = getProduct(state, {
      apiName
    });
    if (!product) return false;
    const {
      id: productId
    } = product;
    const productVersion = getCurrentProductVersion(state, {
      productId
    });
    if (!productVersion) return false;
    const {
      versionNumber
    } = productVersion;
    const restrictionDetails = getAddonRestrictionDetails({
      apiName,
      versionNumber
    });

    // if there is no entry in the AddOnsRestrictionMap for a given add-on, return false
    // this prevents add-ons from showing up as available to purchase by themselves before a hub is selected
    if (!restrictionDetails) return false;
    return !restrictionDetails.isRestricted(state, {
      productConfigurations
    });
  }).map(apiName => getCurrentSkuIdForProduct(state, {
    apiName
  }));
};